/* eslint-disable @typescript-eslint/no-unnecessary-condition */
import { HeaderReleaseSelector } from '@upright/ui/common/generic/components/bou-tool-header/desktop-header/items/release-selector';
import { FlexBox } from '@upright/ui/common/generic/layout/flexbox';
import { useSelector } from 'react-redux';
import { loggedInUser } from '../../../../../../untidy/redux/selectors';
import { useIsFullMaintenanceMode } from '../../../../../../views/root/context/use-is-maintenance-mode';
import { AskAiLink } from './ask-ai-link';
import { LoginItem } from './login-item';
import { NavMenu } from './nav-menu';
import { SignupItem } from './signup-item';
import { UserMenu } from './user-menu';
import { HeaderVersionSelector } from './version-selector';

export function HeaderRightItems() {
  const user = useSelector(loggedInUser);
  const isFullMaintenance = useIsFullMaintenanceMode();
  return (
    <FlexBox sx={{ alignItems: 'center', height: '100%' }}>
      {!isFullMaintenance &&
        (user ? (
          <FlexBox sx={{ gap: 2, alignItems: 'center', height: '100%' }}>
            <AskAiLink />
            <HeaderReleaseSelector />
            <HeaderVersionSelector />
            <UserMenu />
          </FlexBox>
        ) : (
          <FlexBox sx={{ gap: 2, alignItems: 'center', height: '100%' }}>
            <NavMenu />
            <LoginItem />
            {false && <SignupItem />}
          </FlexBox>
        ))}
    </FlexBox>
  );
}
